export default __webpack_public_path__ + "static/media/team-photo4.d1266c89.jpg";